const request = {
  props: {
    subjectGuideItems: {
      type: Array,
      default: () => ([])
    }, value: {
      type: Object,
      default: () => ({}),
    }, type: {
      type: String,
      default: "",
    }

  },
  data() {
    return {
      mixinName: 'request',
      idList: [{}, {}, {}, {}, {}, {}, {}, {}]
    };
  },
  created() {
    this.getSubjectGuideItem()
  },
  methods: {
    changeText(obj) {
      const index = this.list.findIndex((item) => item.title === obj.title);
      if (index >= 0) {
        this.$set(this.list, index, obj);
        if (obj.title === '报名时间') {
          this.anotherContent = obj.anotherContent
        }
      }
      console.warn("未找到符合项");
      this.savePage()
    },

    savePage() {
      this.$emit("change", {
        type: this.com,
        subjectGuideItemDetails: [...this.list],
      });
      /* console.log('type11', {
        type: this.com,
        subjectGuideItemDetails: [...this.list],
      }); */
      // console.log("点击了包存");

    },
    saveData() {
      this.$emit('saveData')
    },
    getSubjectGuideItem() {
      let item = this.subjectGuideItems.find(obj => obj.type === this.com)

      this.api.guideEx
        .getSubjectGuideItem(item.id)
        .then((result) => {
          if (result.success) {

            console.log("this.getSubjectGuideItem1", result.data.type, result.data.subjectGuideItemDetails, result.data.subjectGuideItemDetails[0]);
            this.list = result.data.subjectGuideItemDetails
            if (this.com === '考试详情') {
              this.$set(this.list, 0, result.data.subjectGuideItemDetails[0])
              this.$set(this.list, 1, result.data.subjectGuideItemDetails[1])
              this.$set(this.list, 2, result.data.subjectGuideItemDetails[2])
              console.log(this.list[0].anotherContent, 'listttt');
              if (this.list[0].anotherContent) {

                window.sessionStorage.setItem('anotherContent', JSON.stringify(this.list[0].anotherContent))
              } else {
                sessionStorage.removeItem('anotherContent')
              }

            }
            if (this.com === '考前须知') {

              // const list = val.subjectGuideItemDetails;
              //富文本
              this.textObj = this.list.find((obj) => obj.title === "考试介绍");
              //debugger;
              //评分数组
              this.rateList = this.list.filter((obj) => obj.title === "考试科目");
              //二维码
              this.qList = this.list.filter((obj) => obj.title === "关于我们");
              this.$forceUpdate()
            }
            this.savePage()
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    isShow() {
      if (Array.isArray(this.list)) {
        if (this.list.length === 0) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  }
};
export default request;



// WEBPACK FOOTER //
// ./src/components/addGuide/mixin/index.js